import { RootState } from "../store/store";

export const reviewIsLoading = (state: RootState) => state.review.isLoading;

export const reviewError = (state: RootState) => state.review.error;

export const selectAllReviews = (state: RootState) => state.review.reviewData;

export const selectUserReview = (state: RootState) => state.review.reviewData;
